package com.github.jangalinski.tabweb._foundation.alignment

data object START : Horizontal, CardinalDirection {
  val alignment = LEFT.alignment
}
